import { render, staticRenderFns } from "./HighlightOilMakerStats.vue?vue&type=template&id=5035b6ec&scoped=true&"
import script from "./HighlightOilMakerStats.vue?vue&type=script&lang=js&"
export * from "./HighlightOilMakerStats.vue?vue&type=script&lang=js&"
import style0 from "./HighlightOilMakerStats.vue?vue&type=style&index=0&id=5035b6ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5035b6ec",
  null
  
)

export default component.exports